import type { UserResource } from '@clerk/types'
import { logger } from '@saaga/shared/utils/logger.util'

import type { OnboardingStatus } from './onboarding-wizard.interface'

const ONBOARDING_STATUS_KEY = 'onboardingStatus'

export const readOnboardingStatus = (
  unsafeMetadata: Record<string, unknown>
): OnboardingStatus | undefined => {
  const value = unsafeMetadata[ONBOARDING_STATUS_KEY]
  if (value === 'skipped' || value === 'completed' || value === 'pending') {
    return value
  }
  return undefined
}

export const shouldShowWizard = (status: OnboardingStatus | undefined): boolean =>
  !status || status === 'pending'

export const updateOnboardingMetadata = async (
  user: UserResource,
  status: OnboardingStatus
): Promise<void> => {
  try {
    await user.update({
      unsafeMetadata: {
        ...user.unsafeMetadata,
        onboardingStatus: status,
      },
    })
  } catch (error) {
    logger.error('Failed to update onboarding status:', error)
  }
}
